/* Sentry runtime configuration */
import * as Sentry from "@sentry/react";
import { SENTRY_ENVIRONMENT, SENTRY_RELEASE } from "settings";

function applySentryEnvironment() {
	const client = Sentry.getClient();
	if (!client) return;

	const options = client.getOptions();
	options.environment = SENTRY_ENVIRONMENT;
	options.release = SENTRY_RELEASE;
}

export default applySentryEnvironment;